import styled, {useTheme} from "styled-components";
import { Swiper, SwiperSlide } from 'swiper/react';
import HomepageCardManualsList from "./HomepageCardManualsList";
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";
import __ from "../../utils/translator";
import {withRouter} from "react-router-dom";
import HomepageCardCompletionBar from "../atoms/HomepageCardCompletionBar";
import NewContentBadge from "../atoms/NewContentBadge";
import HomepageCardTitle from "../atoms/HomepageCardTitle";
import {typologies} from "../organisms/HomepageCard";
import HomepageCardTypologyTitle from "../atoms/HomepageCardTypologyTitle";
import RenderOnTablet from "../responsive/RenderOnTablet";

function HomepageCardThemesList({
  history,
  collection,
  themes,
  manuals = []
}) {
  const appTheme = useTheme();
  const stopPropagationEvent = (event) => {
    if (themes.length > 2) {
      event.stopPropagation();
      return false;
    }
  }
  const goToDetailsPage = (event, link) => {
    event.stopPropagation();
    history.push(link);
    return false;
  }

  return (
    <StyledSwiper
      slidesPerView={appTheme.isMobile ? 2 : 3}
      touchMoveStopPropagation
      nested={true}
      spaceBetween={appTheme.isMobile ? 8 : 20}
    >
      {themes.map((theme, index) => (
        <SwiperSlide
          index={index}
          key={theme.id}
        >
          <ThemeCard
            onClick={(event) => goToDetailsPage(event, `/seasonal/${collection.id}/themes/${theme.id}`)}
            cover={theme.cover}
          >
            <BadgesContainer>
              {theme.isNew && (
                <NewContentBadge>{__('Never seen')}</NewContentBadge>
              )}
              {theme.visibleOnlyForOutlets && (
                <Badge>{__('Outlet Only')}</Badge>
              )}
              {theme.confidential && (
                <Badge style={{
                  backgroundColor: 'rgb(204, 22, 22)'
                }}>{__('draft')}</Badge>
              )}
            </BadgesContainer>
            <TitleContainer>
              <RenderOnTablet>
                <HomepageCardTypologyTitle typology={typologies.seasonal} />
              </RenderOnTablet>
              <ThemeName>
                {theme.name}
              </ThemeName>
            </TitleContainer>
            {theme.completionPercentage !== 0 && (
              <ThemeHomepageCardCompletionBar
                percentage={theme.completionPercentage}
              />
            )}
          </ThemeCard>
        </SwiperSlide>
      ))}
      {appTheme.isTablet && manuals.length > 0 && (
        <SwiperSlide index={themes.length}>
          <ThemeCard
            onClick={(event) => goToDetailsPage(event, `/seasonal/${collection.id}/manuals`)}
            cover={collection.cover}
          >
            <TitleContainer style={{ paddingBottom: ".5rem" }}>
              <RenderOnTablet>
                <HomepageCardTypologyTitle typology={typologies.merchandisingManual} />
              </RenderOnTablet>
              <ThemeName>
                {collection.name}
              </ThemeName>
            </TitleContainer>
            <HomepageCardManualsList
              manuals={manuals}
            />
          </ThemeCard>
        </SwiperSlide>
      )}
    </StyledSwiper>
  )
}

export default withRouter(HomepageCardThemesList);

const StyledSwiper = styled(Swiper)`
  width: 100%;
  padding: ${themeResponsiveProperty(".5rem 1rem", ".5rem 1.875rem 1.875rem")};
`;

const ThemeCard = styled.div`
  width: 100%;
  position: relative;
  height: ${themeResponsiveProperty("10.25rem", "17.125rem")};
  background: linear-gradient(0deg, #000 12.64%, rgba(0, 0, 0, 0.00) 50%),
      linear-gradient(0deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.40) 100%),
      url("${(props) => props.cover}"),
      lightgray 50% / cover no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: ${themeResponsiveProperty('.3125rem', '0.5625rem')};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  overflow: hidden;

  * {
    z-index: 1;
  }
`;

const TitleContainer = styled.div`
  padding: ${themeResponsiveProperty('.62rem', '1rem')};
  display: flex;
  gap: .125rem;
  flex-direction: column;
`;

const ThemeName = styled.div`
  color: #FFF;
  font-size: ${themeResponsiveProperty("1rem", "1.25rem")};
  line-height: ${themeResponsiveProperty("1.25rem", "1.625rem")};
  z-index: 2;
`;

const BadgesContainer = styled.div`
  position: absolute;
  inset: ${themeResponsiveProperty('.625rem auto auto .625rem', '1.25rem auto auto 1.25rem')};
  display: flex;
  flex-direction: row;
  gap: ${themeResponsiveProperty('.5rem', '1rem')};
  font-family: 'Din-Medium', sans-serif;
`;

const Badge = styled.div`
  border-radius: .3125rem;
  background-color: #000;
  color: #FFF;
  padding: 0 .625rem;
  line-height: 1.125rem;
  font-size: .625rem;
  text-transform: uppercase;
`

const ThemeHomepageCardCompletionBar = styled(HomepageCardCompletionBar)`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100% !important;
  margin: 0 !important;
`
